import { AnimatePresence } from 'framer-motion';
import { useAssociateRequestContext } from '../../contexts/AssociateRequestProvider';
import { Associate } from '../../types/associates';
import AssociateRequestDetailsModal from '../CommonComps/Modals/AssociateRequestDetailsModal';

const AssociateRequestModalSection = () => {
  // integration of context hooks here
  const { associate, setAssociate, showDetailsModal, setShowDetailsModal } =
    useAssociateRequestContext();

  console.log('ASSOCIATE: ', associate);

  // rendering associate request modal section component here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showDetailsModal && (
          <AssociateRequestDetailsModal
            associate={associate as Associate}
            handleModalClose={() => {
              setShowDetailsModal(false);
              setAssociate(null);
            }}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default AssociateRequestModalSection;
